import { render } from "./newsList1.vue?vue&type=template&id=0c3b1bec&scoped=true"
import script from "./newsList1.vue?vue&type=script&lang=js"
export * from "./newsList1.vue?vue&type=script&lang=js"

import "./newsList1.vue?vue&type=style&index=0&id=0c3b1bec&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c3b1bec"]])

export default __exports__